import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { Route, Switch } from 'react-router-dom'
import AuthenticationContext from '../Authentication/AppContext'
import AuthService from '../Authentication/AuthService'
import License from '../pages/settings/License'
import { AppRouter } from '../routing/AppRouter'
import { AccessDenied } from './AccessDenied'
import { Footer } from './Footer'
import { Header } from './Header'
import { Login } from './Login'
import { Logout } from './Logout'
import { PasswordChange } from './PasswordChange'

function RootContainer() {
  const { auth, userPermissions, needsPasswordChange, isLicensed, licenseStatus, isClusterSlotReserved } = React.useContext(AuthenticationContext)

  return (
    <div className='bg-secondary min-h-100 d-flex'>
      <Container fluid className='bg-striped min-vh-100 d-flex flex-column'>
        <Row>
          <Col className='p-0'>
            <Header />
          </Col>
        </Row>
        <Row className='flex-grow-1'>
          {auth &&
            (AuthService.isTokenExpired(auth) ? (
              <Logout />
            ) : needsPasswordChange ? (
              <PasswordChange />
            ) : userPermissions.length === 0 ? (
              <AccessDenied />
            ) : isLicensed ? (
              licenseStatus === 'ACQUIRED' && !isClusterSlotReserved ? (
                <Col>
                  <License />
                </Col>
              ) : (
                <AppRouter />
              )
            ) : (
              <Col>
                <License />
              </Col>
            ))}
          <Switch>
            <Route key={'/logout'} exact path={'/logout'} component={Logout} />
            <Route component={Login} />
          </Switch>
        </Row>
        <Row>
          <Col className='p-0'>
            <Footer />
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default RootContainer
